export enum Contexts {
  campaign = 'CAMPAIGN',
  sale = 'SALE',
  upgrade = 'UPGRADE',
  paymentChange = 'PAYMENT_CHANGE',
  retention = 'RETENTION',
  activateAutoRecharge = 'ACTIVATE_AUTO_RECHARGE',
  AutoRechargePaymentChange = 'AUTO_RECHARGE_PAYMENT_CHANGE'
}
